export default {
    SET_MOVIMIENTOS_POR_PAGAR: (state, payload) => {
        state.movimientosCuentasPorPagar = payload  
    },
    SET_MOVIMIENTOS_POR_PAGAR_FILTRO: (state, payload) => {
        state.movimientosCuentasPorPagarFiltros = payload
    },
    MOVIMIENTOS_CUENTAS_POR_PAGAR_COUNT: (state, payload) => {
        state.movimientosCuentasPorPagarCount = payload
    },
    SET_MOVIMIENTOS_POR_COBRAR: (state, payload) => {
        state.movimientosCuentasPorCobrar = payload
    },
    SET_MOVIMIENTOS_POR_COBRAR_FILTRO: (state, payload) => {
        state.movimientosCuentasPorCobrarFiltros = payload
    },
    MOVIMIENTOS_CUENTAS_POR_COBRAR_COUNT: (state, payload) => {
        state.movimientosCuentasPorCobrarCount = payload
    },
    SET_COMPRA: (state, payload) => {
        state.compra = payload
    },
    SET_COMPRA_FILTRO: (state, payload) => {
        state.compraFiltros = payload
    },
    SET_VENTA: (state, payload) => {
        state.venta = payload
    },
    SET_VENTA_FILTRO: (state, payload) => {
        state.ventaFiltros = payload
    },
    COMPRA_COUNT: (state, payload) => {
        state.compraCount = payload
    },
    LAST_NUMBER_CONTROL_COMPRA: (state, payload) => {
        state.lastNumberControlCompra = payload.c;
        state.lastNumberFCompra = payload.f;
    },
    VENTA_COUNT: (state, payload) => {
        state.ventaCount = payload
    },
    LAST_NUMBER_CONTROL_VENTA: (state, payload) => {
        state.lastNumberControlVenta = payload.c;
        state.lastNumberFVenta = payload.f;
    },
}